'use client';

import { Suspense } from 'react';

import { TikTokHandleConflictModal } from './TikTokHandleConflictModal';

/**
 * TikTok 인증 에러 핸들러
 *
 * URL 파라미터로 전달되는 TikTok 인증 관련 에러를 감지하고 적절한 UI를 표시합니다.
 * - handle_already_linked: TikTok 핸들 중복 에러
 */
export const TikTokAuthErrorHandler = () => {
  return (
    <Suspense fallback={null}>
      <TikTokHandleConflictModal />
    </Suspense>
  );
};
